import { useState, useEffect, useRef } from 'react';

/**
 * Custom hook to manage hover state for AG Grid cell renderers
 * Prevents stuck hover states when quickly moving between rows
 */
const useCellHover = () => {
    const [isHovered, setIsHovered] = useState(false);
    const containerRef = useRef(null);
    const timerRef = useRef(null);

    useEffect(() => {
        const cellElement = containerRef.current?.closest('.ag-cell');
        const rowElement = containerRef.current?.closest('.ag-row');

        const handleGlobalMouseMove = (e) => {
            // Clear any pending timer
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }

            // Check if mouse is over the row
            if (rowElement && !rowElement.contains(e.target)) {
                setIsHovered(false);
            } else if (cellElement && cellElement.contains(e.target)) {
                setIsHovered(true);
            } else if (rowElement && rowElement.contains(e.target)) {
                // Mouse is in the row but not in this cell
                // Delay hiding to prevent flicker
                timerRef.current = setTimeout(() => {
                    if (cellElement && !cellElement.matches(':hover')) {
                        setIsHovered(false);
                    }
                }, 50);
            }
        };

        document.addEventListener('mousemove', handleGlobalMouseMove);

        return () => {
            document.removeEventListener('mousemove', handleGlobalMouseMove);
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);

    return { isHovered, containerRef };
};

export default useCellHover;
